import { mapToCanActivate, Routes } from '@angular/router'
import { MsalGuard } from '@azure/msal-angular'
import {
   AuthGuardService,
   CanActivateGuardService,
   PublicOnlyGuardService
} from '@appShared/services'
import { IFramePlayerComponent } from '@appShared/components/iframe-player/iframe-player.component'
import {
   AuthResponseComponent,
   ErrorComponent,
   LandingComponent,
   LoginFailedComponent,
   PageNotFoundComponent,
   ShellComponent,
   UnauthorizedComponent,
} from './containers'
import { CONTENT_ROUTES } from './content/content.routes'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'
import { environment } from '@appEnvironments/environment'

export const APP_ROUTES: Routes = [
   {
      path: '',
      component: ShellComponent,
      children: [
         {
            path: '',
            canActivate: [PublicOnlyGuardService],
            component: LandingComponent
         },
         ...CONTENT_ROUTES, /* If NOT lazy-loading */
         //{
         //   path: environment.routes.content.baseUri,
         //   canActivate: mapToCanActivate([AuthGuardUserService]),
         //   loadChildren: () =>
         //      import('./content/content.routes').then(mod => mod.CONTENT_ROUTES)
         //},
         {
            path: environment.playerUri,
            canActivate: [CanActivateGuardService, MsalGuard, AuthGuardService],
            component: IFramePlayerComponent
         },
         //...MEMBER_ROUTES, /* If NOT lazy-loading */
         //{
         //   path: environment.routes.member.baseUri,
         //   canActivate: mapToCanActivate([AuthGuardService]),
         //   loadChildren: () =>
         //      import('./member/member.routes').then(routes => routes.MEMBER_ROUTES)
         //}
         {
            path: SITE_DIRECTORY_ROUTES.error.baseUri,
            component: ErrorComponent
         },
         {
            path: SITE_DIRECTORY_ROUTES.loginFailed.baseUri,
            component: LoginFailedComponent
         },
         {
            path: SITE_DIRECTORY_ROUTES.unauthorized.baseUri,
            component: UnauthorizedComponent
         },
         {
            path: SITE_DIRECTORY_ROUTES.auth.baseUri,
            component: AuthResponseComponent
         },
         {
            path: SITE_DIRECTORY_ROUTES.pageNotFound.baseUri,
            component: PageNotFoundComponent
         },
         { path: '**', redirectTo: '404', pathMatch: 'full' }
      ]
   }
]
